import styled from 'styled-components';
import SearchTypeAhead from './SearchTypeAhead';
import ServerStylesConditionalWrapper from '../../shared/ServerStylesConditionalWrapper';
import { device, shadows } from '../../../utils/styled-component-mixins';

// !importants are needed to override inline styles from react-bootstrap-typeahead
const SearchResultsTypeAheadStyled = styled.div`
  height: 100%;
  margin-bottom: 2.8rem;
  width: 100%;

  @media ${device.desktop} {
    margin-bottom: 5.2rem;
  }

  .rbt {
    height: 100%;

    input {
      ${shadows.inputShadow};
      height: 5.6rem;
      padding-left: 1.6rem;
      padding-right: 4rem;
      width: 100%;
    }

    input::placeholder {
      color: transparent;
    }

    input:-ms-input-placeholder {
      color: transparent;
    }

    input:-moz-placeholder {
      color: transparent;
    }

    input::-webkit-input-placeholder {
      color: transparent;
    }

    &-aux {
      position: absolute;
      right: 1.85rem;

      @media ${device.desktop} {
        margin-right: 0;
      }

      button[type='submit'] {
        border: none;
        height: 2rem;
        margin: 0;
        padding: 0;
        pointer-events: auto !important;
        position: relative;
        width: 2rem;

        &:focus {
          @media ${device.desktop} {
            outline: 1px solid black;
          }
        }

        .material-icons-round {
          top: 0;
        }
      }
    }

    &-menu {
      border: 0;
      border-radius: 0;
      inset: 101% auto auto auto !important;
      margin: 0;
      transform: none !important;

      @media ${device.desktop} {
        inset: 100% auto auto auto !important;
      }
    }

    .dropdown-menu {
      ${shadows.inputShadow};
      max-height: calc(100vh - 13.6rem) !important;
      padding: 4rem 1.6rem;

      @media ${device.desktop} {
        max-height: none !important;
        padding: 2.4rem 4rem;
      }

      .dropdown-item {
        padding: 0rem;
        margin-top: 1.6rem;

        @media ${device.desktop} {
          margin-top: 0.8rem;
        }

        &:hover {
          background-color: var(--light-grey);
        }

        &:first-child {
          margin-top: 0;
        }

        &:last-child {
          color: var(--cta-blue);
          margin-top: 2.4rem;

          @media ${device.desktop} {
            margin-top: 2.4rem;
            padding-top: 2.4rem;
            border-top: 1px solid var(--grey);
          }

          .ellipsis-container-left {
            border-bottom: 2px solid transparent;
            color: var(--button-tertiary);
            padding: 0;
            position: relative;
            text-decoration: none;
            text-transform: none;
            transition: background-size 0.3s;

            &::after {
              background-color: var(--button-tertiary);
              bottom: 0;
              content: '';
              display: block;
              height: 2px;
              left: 0;
              position: absolute;
              transition: width 0.3s;
              width: 0;
            }
          }

          &:hover,
          &.active {
            background-color: var(--white);
            color: var(--cta-blue);

            .ellipsis-container-left {
              &::after {
                width: 100%;
              }
            }
          }
        }

        &:only-child {
          border-top: none;
          color: var(--charcoal);
          margin-top: 0;
          padding-top: 0;
        }

        &.active {
          background-color: var(--light-grey);
          color: var(--charcoal);
        }

        .ellipsis-container-right {
          font-size: 1.2rem;
          font-style: italic;
        }
      }

      * {
        font-size: 1.4rem;
        line-height: 2.4rem;
      }
    }
  }
`;

const SearchResultsTypeAhead = (props) => (
  <ServerStylesConditionalWrapper>
    <SearchResultsTypeAheadStyled>
      <SearchTypeAhead
        searchPageTypeAheadEnterHandler={props.searchPageTypeAheadEnterHandler}
        id="site-search"
        renderCustomInput={true}
      ></SearchTypeAhead>
    </SearchResultsTypeAheadStyled>
  </ServerStylesConditionalWrapper>
);

export default SearchResultsTypeAhead;
